import React from "react";
import Navbar from "./navbar";
import Footer from "./footer";

export default function PrivacyPolicy() {
  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <section className="relative container  flex flex-col mt-[100px] mb-[100px]">
          <h1 className="text-sidom-orange container mt-[100px] text-3xl md:text-[40px] lg:text-[45px] px-2 md:px-0 lg:px-0 font-extrabold text-left mb-[60px]">
            POLÍTICAS DE PRIVACIDAD
          </h1>
          <div className="flex-1  flex flex-col items-center justify-start">
            <div className="  ">
              <p className="text-xs sm:text-sm  lg:text-base text-sidom-dark text-justify mb-4 leading-6 ">
                SIDOMSuite, es una empresa mundial que desarrolla tecnología
                para ayudar a las empresas a impulsar su comercio internacional.
                <br /> <br /> 1. Alcance Esta política de privacidad
                (“Política“) explica cómo procesamos datos personales de
                clientes y visitantes de nuestros sitios web (“Sitios“) y
                usuarios de nuestros servicios (“Servicios“) como controladora o
                empresa bajo las leyes de privacidad aplicables. Cuando
                recopilamos datos personales como encargados del tratamiento,
                esto es, en nombre de nuestros clientes comerciales, procesamos
                datos personales en conformidad con nuestro contrato con ellos,
                y en ese caso será aplicable su política de privacidad. Esta
                Política no se aplica a los datos personales de empleados o
                candidatos de empleo, ni a la información exenta bajo las leyes
                aplicables. Brindaremos avisos adicionales cuando sea necesario
                para aclarar nuestras prácticas de privacidad en circunstancias
                específicas. <br /> <br /> 2. Datos personales que recopilamos
                Si bien los datos personales que recopilamos varían según su uso
                de nuestros Servicios y nuestras interacciones con usted,
                podemos recopilar datos personales de usted, de fuentes de
                terceros y de manera automática en las siguientes
                circunstancias: Datos personales que recopilamos directamente de
                usted. Podemos recopilar la siguiente información personal de su
                parte: Atención al cliente y asistencia técnica. Cuando nos
                contacta para recibir asistencia técnica u otras solicitudes de
                atención al cliente, quedan asentados los tickets y otros
                registros de sus solicitudes/comunicaciones relacionadas. Por
                ejemplo, cuando utiliza nuestro formulario de “Contáctenos”,
                podemos recopilar detalles, como nombre, país, dirección de
                correo electrónico y la naturaleza de su solicitud. También
                podemos recopilar información sobre su empresa, cargo y sector,
                si elige proporcionarla. Comunicaciones. Recopilamos la
                información que proporciona, como información de contacto y
                registros de nuestras comunicaciones. Información de
                transacciones y facturación. Recopilamos información cuando
                compra uno de nuestros productos o servicios. Encuestas. Cuando
                responde una encuesta, recopilamos la respuesta, que depende del
                tipo de encuesta, pero puede incluir información de contacto y
                la satisfacción con un producto o servicio. Eventos. También
                recopilamos datos personales relacionados con el registro y
                participación en eventos que organizamos o patrocinamos.
                Sorteos, concursos y promociones. Si participa en sorteos,
                concursos y promociones que ofrecemos, recopilaremos su nombre,
                edad, país de residencia, dirección de correo electrónico y otra
                información de registro relacionada con estas actividades. En
                algunas jurisdicciones, estamos obligados a divulgar el nombre y
                otra información personal de los ganadores. Grabación de
                imagen/video y transcripciones. Es posible que los sistemas de
                seguridad/vigilancia de video tomen su imagen cuando ingresa a
                las instalaciones de SIDOMSuite o durante eventos o sesiones de
                filmación ya sea de marketing o públicos, y obtengamos grabación
                de audio y video y transcripción durante reuniones. Otro tipo de
                información. Podemos recopilar otros datos personales si usted
                da su consentimiento o si es razonable según la naturaleza de
                las circunstancias. Datos personales recopilados por terceros.
                Podemos recopilar datos personales sobre usted de fuentes de
                terceros, como bases de datos públicas, asesores y agentes,
                empresas vinculadas y filiales, proveedores de servicios de
                Internet, sistemas operativos y plataformas, intermediarios de
                datos y proveedores de analítica de datos, empresas de
                publicidad y marketing, socios comerciales, clientes,
                plataformas de redes sociales u otros. Datos personales
                recopilados automáticamente. Cuando visita nuestros Sitios o
                utiliza nuestros Servicios, nosotros y terceros podremos
                recopilar datos personales, incluso mediante el uso de cookies,
                píxeles de seguimiento y otras tecnologías similares, tales
                como: Información del dispositivo y navegación. Cuando visita
                nuestro Sitio, podemos recopilar información, que ciertas leyes
                consideran datos personales, como la dirección IP, el tipo de
                navegador, nombres de dominio, horarios de acceso, marcas de
                fecha y hora, el sistema operativo, el idioma, el tipo de
                dispositivo, el identificador único o en línea, el proveedor de
                servicios de Internet, URL de referencia y salida, datos de
                flujo de clics y otros tipos de información similares sobre el
                dispositivo y la navegación. Actividades y uso. También
                recopilamos información de actividades relacionada con su uso
                del Sitio, como información sobre los enlaces que selecciona,
                las búsquedas que realiza, las funciones que utiliza, los
                elementos que visualiza, el tiempo que dedica a ciertas páginas,
                las interacciones con nuestro contenido, la información de
                archivos de registro y otros tipos de información de actividad y
                uso. Información de la ubicación. También podemos recopilar o
                derivar información de ubicación general sobre usted, por
                ejemplo, a través de su dirección IP. <br /> <br /> 3. Para qué
                usamos los datos personales En general, usamos los datos
                personales para los siguientes propósitos: Brindar atención al
                cliente y asistencia técnica. Para brindar nuestros Servicios y
                operar nuestro Sitio, transmitirle información útil sobre su uso
                de los servicios, solucionar problemas y brindarle asistencia
                técnica, responder a sus consultas, cumplir con sus pedidos y
                solicitudes, comunicarnos con usted y para propósitos similares
                de atención y asistencia técnica. Comunicaciones. Para responder
                a sus preguntas y cumplir con sus pedidos y solicitudes;
                enviarle comunicaciones que haya solicitado o que puedan
                interesarle; y notificarle sobre cambios en nuestros Servicios.
                Analítica y mejoras. Para entender mejor la forma en que los
                usuarios acceden al Sitio y los Servicios y los utilizan, así
                como nuestros otros productos y ofertas; y para otros fines de
                investigación y análisis, como evaluar y mejorar nuestro Sitio,
                Servicios y operaciones comerciales, desarrollar nuestro Sitio,
                Servicios y funcionalidades, y para fines internos de control de
                calidad y capacitación. Personalización y adaptación. Para
                adaptar el contenido que enviamos o presentamos en el Sitio y
                los Servicios, como ofrecer la personalización de la ubicación y
                ayuda e instrucciones personalizadas, y para personalizar de
                otra manera sus experiencias. Marketing y publicidad. Para
                enviarle información sobre nuestros Servicios, como ofertas,
                promociones, boletines informativos y cualquier otra información
                que acepte recibir; y para gestionar, analizar, medir y mejorar
                nuestras campañas publicitarias. Planificación y organización de
                eventos. Para la planificación y organización de eventos,
                incluido el registro, la asistencia, el contacto con otros
                asistentes y la posibilidad de ofrecerle eventos y Servicios
                relevantes. Investigación y encuestas. Para administrar
                encuestas y cuestionarios, por ejemplo, para fines de
                investigación de mercado o satisfacción del cliente. Sorteos,
                concursos y promociones. Para facilitar su participación en
                sorteos, concursos y promociones, para comunicarnos con usted
                por su participación en el sorteo, concurso o promoción .
                Seguridad y protección de derechos. Para proteger el Sitio, los
                Servicios y nuestras operaciones comerciales; prevenir y
                detectar fraudes, actividades y accesos no autorizados, y otros
                tipos de uso indebido; cuando creemos que es necesario
                investigar, prevenir o tomar medidas con respecto a actividades
                ilegales, sospechas de fraude, situaciones que involucren
                amenazas potenciales a la seguridad o derechos legales de
                cualquier persona o tercero, o violaciones a nuestros términos o
                a esta Política. Acciones legales y obligaciones. Para cumplir
                con la ley y nuestras obligaciones legales, responder en el
                marco de procesos legales y por cuestiones relacionadas con
                acciones legales. Apoyo general al aspecto administrativo y
                operativo. Para realizar tareas relacionadas con la
                administración general de nuestra empresa, tareas de
                contabilidad, auditoría, cumplimiento, mantenimiento de
                registros y capacidades legales. Para mejorar la experiencia del
                cliente y optimizar nuestros procesos internos, utilizamos un
                sistema de gestión de relaciones con los clientes (CRM) que
                incorpora inteligencia artificial. Esta tecnología nos permite
                analizar grandes volúmenes de datos de manera eficiente,
                personalizar nuestras comunicaciones y ofrecer un servicio más
                personalizado. La información recopilada, como datos de
                contacto, historial de compras y preferencias, puede ser
                procesada por algoritmos de aprendizaje automático para generar
                insights valiosos y mejorar nuestras operaciones. Garantizamos
                que el uso de la inteligencia artificial se realiza cumpliendo
                con todas las normativas de protección de datos aplicables y que
                tus datos personales siempre están protegidos. <br /> <br /> 4.
                Divulgación de datos personales En general, divulgamos y
                permitimos que terceros accedan a los datos personales de las
                siguientes maneras: Afiliadas corporativas. Podemos divulgar
                datos personales a nuestras afiliadas corporativas como parte de
                nuestras operaciones comerciales globales, y para fines y usos
                que respeten esta Política. Procesadores y proveedores de
                servicios. Podemos divulgar datos personales a los proveedores
                que brindan servicios en nuestro nombre, como proveedores de
                servicios de TI, de alojamiento web, de servicios de correo
                electrónico, de chatbots, centros de llamadas, etc. Terceros,
                plataformas y servicios. Podemos divulgar o poner a disposición
                datos personales a plataformas y proveedores externos que
                utilizamos para proporcionar u ofrecer ciertas funcionalidades o
                partes del Sitio y los Servicios, o según sea necesario para
                responder a sus solicitudes. Redes de marketing y publicidad.
                Podemos divulgar información que nos proporcione a redes
                publicitarias, motores de búsqueda, plataformas de redes
                sociales, patrocinadores y/o servicios de medición de tráfico,
                que utilizan estos datos para mejorar y medir la eficiencia de
                nuestros anuncios, y para mostrarle anuncios en sitios web y
                plataformas de terceros. Proveedores de analítica externos.
                También podemos contratar empresas de analítica externas para
                recopilar información sobre cómo accede y utiliza nuestro Sitio
                y Servicios, con el objeto de mejorarlos y para otros fines de
                investigación y análisis. Cumplimiento, gobernanza y requisitos
                legales. Podemos divulgar datos personales para cumplir con
                obligaciones legales y de cumplimiento, y para responder ante
                procesos legales y eventos relacionados con acciones legales.
                Por ejemplo, podemos divulgar datos personales en respuesta a
                citaciones, órdenes judiciales y otras solicitudes legales por
                parte de entes reguladores y autoridades de la ley. También
                podemos divulgar información relacionada con litigios y otras
                reclamos o acciones legales, incluidos datos personales, para
                realizar tareas internas de contabilidad, auditoría,
                cumplimiento, mantenimiento de registros y capacidades legales.
                Además, podemos divulgar los nombres de los ganadores de sorteos
                y concursos, de acuerdo con la ley aplicable. Transacciones
                corporativas. Podemos divulgar datos personales como parte de
                transacciones corporativas (por ejemplo, fusiones,
                adquisiciones, quiebras u otras transacciones similares) y en
                contemplación de dichas transacciones (por ejemplo, debida
                diligencia). Socios comerciales. Podemos divulgar sus datos
                personales con socios que estén organizando o coorganizando un
                evento con SIDOMSuite. Otros casos. Podemos divulgar sus datos
                personales para otros fines, para lo cual lo notificaremos y le
                solicitaremos el consentimiento cuando sea necesario. Datos
                agregados y/o anonimizados. Podemos utilizar y divulgar datos
                agregados, anonimizados y otros datos no identificables
                relacionados con nuestra empresa y los Servicios para fines de
                control de calidad, análisis, investigación, desarrollo y otros
                propósitos. Cuando usemos, divulguemos o procesemos datos
                anonimizados, mantendremos y utilizaremos la información sin
                identificar y no intentaremos volver a identificarla, excepto
                cuando lo permita la ley. <br /> <br /> 5. Transferencias
                internacionales de datos Sus datos personales pueden ser
                tratados dentro y fuera del Espacio Económico Europeo (EEE) dada
                la dimensión internacional de SIDOMSuite, todo ello siempre en
                cumplimiento de los límites contractuales en materia de
                confidencialidad y seguridad y de acuerdo con las leyes y
                regulaciones aplicables relacionadas con la protección de datos
                personales. En ningún caso, se comunicarán sus datos personales
                a sujetos o entidades que no tengan la autorización para su
                legítimo tratamiento. Asimismo, por eficiencias del servicio,
                algunos de nuestros proveedores (encargados del tratamiento)
                están ubicados en países situados fuera del EEE, o, estando
                ubicados en el EEE, comparten la información con otras entidades
                ubicadas fuera de dicho territorio. Cuando transfiramos sus
                datos personales fuera del EEE, para ser tratados por las
                empresas vinculadas y filiales de SIDOMSuite establecidas fuera
                del EEE, lo haremos de conformidad con Reglamento (UE) 2016/679
                del Parlamento Europeo y del Consejo de 27 de abril de 2016
                relativo a la protección de las personas físicas en lo que
                respecta al tratamiento de datos personales y a la libre
                circulación de estos datos (RGPD). Concretamente, las
                transferencias se realizarán en cumplimiento con las garantías
                adecuadas requeridas por la normativa aplicable. <br /> <br />{" "}
                6. Bases legales Tenemos derecho a usar sus datos personales a
                partir de (i) nuestro interés legítimo, como para investigación
                y desarrollo, para comercializar y promocionar nuestros
                Servicios, para proteger nuestros derechos e intereses legales,
                en la medida en que sus intereses o derechos fundamentales no
                prevalezcan; (ii) su consentimiento para hacerlo para un fin
                específico; o (iii) la necesidad de procesar sus datos para
                cumplir con una obligación legal. <br /> <br /> 7. Cookies y
                otros mecanismos de seguimiento Nosotros y otros terceros
                utilizamos cookies, píxeles de seguimiento y otros mecanismos de
                seguimiento similares para recopilar automáticamente información
                sobre la actividad de navegación, el tipo de dispositivo y otra
                información similar dentro de nuestro Sitio y Servicios.
                Utilizamos esta información, por ejemplo, para analizar y
                comprender cómo accede a nuestro Sitio y Servicios, cómo los
                utiliza y cómo interactúa con ellos; para identificar y resolver
                errores y fallas en nuestro Sitio y Servicios; para evaluar,
                asegurar, proteger, optimizar y mejorar el rendimiento de
                nuestro Sitio y Servicios; con fines de marketing, publicidad,
                medición y análisis; y para personalizar el contenido en nuestro
                Sitio y Servicios. También podemos anonimizar o agregar dicha
                información para analizar tendencias, administrar nuestro Sitio
                y Servicios, recopilar información demográfica amplia para usos
                agregados y para cualquier otro fin lícito. Cookies. Las
                “cookies” son identificadores alfanuméricos utilizados para
                fines de seguimiento. Algunas cookies nos permiten facilitar su
                navegación, mientras que otras se utilizan para habilitar un
                proceso de inicio de sesión más rápido, respaldar la seguridad y
                el rendimiento del Sitio, o permitirnos rastrear la actividad y
                los datos de uso dentro del Sitio y en otros sitios web. Píxeles
                de seguimiento y otras tecnologías similares. Los píxeles de
                seguimiento (a veces llamados faros web o GIF transparentes) son
                gráficos diminutos con un identificador único, que tienen una
                función similar a las cookies. En ocasiones, utilizamos estas
                tecnologías de seguimiento para comprender la actividad de los
                usuarios, ayudar a gestionar el contenido y recopilar
                estadísticas de uso, y en correos electrónicos para saber cuándo
                se han abierto o reenviado, de modo que podamos hacer un
                seguimiento del índice de respuesta y evaluar la eficiencia de
                nuestras comunicaciones. Herramientas analíticas provistas por
                terceros. Utilizamos herramientas de terceros, como Google
                Analytics, operadas por empresas externas para evaluar el uso de
                nuestro Sitio. Estas empresas de analítica utilizan cookies,
                píxeles y otras tecnologías de seguimiento para recopilar datos
                de uso sobre nuestro Sitio y proporcionarnos informes y métricas
                que nos ayudan a evaluar el uso de nuestro Sitio, optimizarlo y
                mejorar el rendimiento y la experiencia del usuario.
                <br /> <br /> 8. Seguridad Tenemos implementados los estándares
                de seguridad del mercado necesarios para la transmisión y
                resguardo seguro de los datos personales. Más allá de esto,
                ninguna transmisión de datos a través de Internet puede
                garantizarse que sea 100% segura. Por lo tanto, si bien nos
                esforzamos por proteger sus datos personales, no existe una
                garantía total que aún con todas las tecnologías de seguridad
                implementadas los datos no puedan sufrir algún incidente de
                seguridad. Usted utiliza nuestro Sitio y Servicios, y nos
                proporciona sus datos personales bajo su propia responsabilidad.
                <br /> <br /> 9. Por cuánto tiempo retenemos sus datos
                personales Sus datos personales se conservarán hasta que sea
                necesario para cumplir con los propósitos y usos para los cuales
                fueron recopilados según lo establecido en esta Política. Si
                solicita que eliminemos sus datos personales de nuestras bases
                de datos, tenga en cuenta que igualmente podemos retener sus
                datos personales según sea necesario para cumplir con nuestras
                obligaciones legales, solicitudes regulatorias, resolver
                disputas y hacer cumplir nuestros acuerdos. El tiempo de
                guardado máximo de los datos es de 10 años. Pasado este período
                podremos desestimar o solicitar que vuelvan a cargarlos.
                <br /> <br /> 10. Qué derechos puede ejercer en relación con el
                tratamiento de sus datos personales Puedes ejercitar los
                derechos de acceso, rectificación, supresión, portabilidad,
                limitación del tratamiento y oposición mediante carta dirigida
                al domicilio social de la compañía, o mediante correo
                electrónico dirigido a ciberseguridad@sidomsuite.com
                acompañando, si fuera necesario acreditar tu identificación, de
                copia de tu documento nacional de identidad o documento
                identificativo equivalente. Asimismo, te informamos que en caso
                de no considerar atendidos de forma debida tus derechos
                personales, podrás presentar una reclamación ante la autoridad
                de control competente. No obstante, te recomendamos que antes de
                presentar cualquier denuncia o reclamación ante la autoridad de
                control competente contactes con nosotros, y especialmente con
                el DPD de SIDOMSuite (ciberseguridad@sidomsuite.com) a fin de
                analizar la situación concreta que corresponda, e intentar, en
                su caso, buscar una solución eficaz y amistosa.
                <br /> <br /> 11. Sus preferencias sobre la privacidad
                Comunicaciones para acciones de marketing. Podemos enviar
                correos electrónicos promocionales u otras comunicaciones
                similares de forma regular. Puede optar por no recibir estas
                comunicaciones siguiendo las instrucciones proporcionadas en la
                comunicación, por ejemplo, mediante la opción “cancelar la
                suscripción”. Si opta por no recibir contenido promocional de
                nuestra parte, igualmente podríamos enviarle comunicaciones
                sobre su cuenta o cualquier Servicio que haya solicitado o
                recibido de nosotros. Programas de elección de anuncios de la
                industria. También puede controlar la forma en que las empresas
                publicitarias externas utilizan la información que recopilan
                sobre sus visitas a nuestro Sitio y a los de terceros, a fin de
                mostrarle publicidad dirigida más relevante. Si se encuentra en
                los EE. UU., puede obtener más información y optar por no
                recibir anuncios dirigidos de redes publicitarias de terceros en
                aboutads.info/choices (Alianza de Anuncios Digitales, DAA).
                También puede descargar la herramienta DAA AppChoices para
                controlar la publicidad dirigida por intereses en aplicaciones
                en su dispositivo móvil. Configuración de cookies. Puede ajustar
                la configuración de las cookies haciendo clic en “Preferencias
                de cookies” al pie de nuestra página web. Los visitantes de
                nuestro Sitio que deshabiliten las cookies podrán navegar por el
                sitio, pero es posible que algunas funciones no sirvan. Si
                accede a nuestro Sitio desde un dispositivo diferente o desde un
                navegador diferente en el mismo dispositivo, también deberá
                aplicar la configuración de cookies para ese navegador y/o
                dispositivo. Señales del navegador. En la medida que lo exija la
                ley aplicable, si nuestro Sitio detecta que su navegador está
                transmitiendo una señal de preferencia de exclusión, como una
                señal de “control de privacidad global” (GPC), consideraremos
                esa señal para excluir a ese navegador de las cookies dirigidas
                en nuestro Sitio. Si accede a nuestro Sitio desde un dispositivo
                o un navegador diferente, también deberá aplicar el GPC para ese
                navegador y/o dispositivo. No respondemos a las señales de “no
                rastrear”.
                <br /> <br /> 12. Datos personales de menores de edad Nuestro
                Sitio web está orientado al público general. El Sitio y los
                Servicios no están diseñados para menores de edad, y no
                recopilamos voluntariamente datos personales de menores.
                <br /> <br /> 13. Enlaces externos Nuestros Sitios y Servicios
                pueden contener enlaces a sitios web o características de
                terceros. Esta Política no rige el acceso y uso de tales sitios
                web o funcionalidades citadas, sino que queda a cargo de las
                políticas de privacidad de esos terceros. No nos hacemos
                responsables de las prácticas de información de dichos terceros,
                incluida la recopilación de sus datos personales. Debería
                revisar las políticas de privacidad y los términos de cualquier
                sitio web de terceros antes de acceder a esos sitios web o usar
                esas funcionalidades.
                <br /> <br /> 14. Aviso de recopilación y Derechos de privacidad
                de California Esta sección de la Política (el “Aviso de
                privacidad de California”) brinda información adicional para los
                residentes de California (“usted”) y describe nuestras prácticas
                de manejo de la información en conformidad con las leyes de
                privacidad de California aplicables, incluida la Ley de
                Privacidad del Consumidor de California y las regulaciones allí
                establecidas, así como sus enmiendas (la “CCPA”). En esta
                sección, “Información personal” se refiere a información que
                identifica, se relaciona, describe, puede asociarse
                razonablemente con, o podría ser razonablemente vinculada,
                directa o indirectamente, con un residente u hogar específico de
                California. Esta sección no hace referencia ni se aplica a
                nuestro manejo de la información disponible de forma pública o
                Información personal que de otra manera esté exenta según la
                CCPA. Categorías de información personal que recopilamos y
                divulgamos. La siguiente tabla especifica las categorías de
                Información personal que podríamos recopilar sobre usted (y que
                podríamos haber recopilado en los últimos 12 meses), según la
                definición de la CCPA, así como las categorías de terceros a
                quienes podemos divulgar esta información para cumplir objetivos
                corporativos o comerciales. Conforme a la forma en que utilice
                los Servicios, podríamos recopilar y divulgar las siguientes
                categorías de Información personal. Venta y divulgación de
                Información personal. Asimismo, la CCPA define “venta” como
                divulgar o poner a disposición de un tercero Información
                personal a cambio de una compensación monetaria u otro beneficio
                de valor, mientras que “divulgación” incluye divulgar o poner a
                disposición Información personal a un tercero a fin de realizar
                publicidad conductual de contexto cruzado. Si bien no divulgamos
                Información personal a terceros a cambio de una compensación
                monetaria, en ocasiones divulgamos las siguientes categorías de
                Información personal: identificadores, perfiles e inferencias, e
                información sobre actividades en la red o en otros medios
                electrónicos a redes publicitarias de terceros, proveedores de
                analítica de datos y redes sociales para fines de marketing y
                publicidad. No vendemos ni divulgamos Información personal
                sensible, ni vendemos ni divulgamos Información personal de
                individuos que sepamos que tienen menos de dieciséis (16) años.
                Fuentes de Información personal. Como se describe en detalle en
                la Sección 2: Datos personales que recopilamos, recopilamos
                Información personal de las siguientes fuentes: directamente de
                usted; de redes publicitarias; de proveedores de análisis de
                datos; de redes sociales; de proveedores de servicios de
                Internet; de sistemas operativos y plataformas; de entidades
                afiliadas; y de entidades gubernamentales. Retención.
                Conservamos la Información personal que recopilamos solo en la
                medida razonablemente necesaria para los fines descritos
                anteriormente o especificados al momento de la recopilación.
                Retenemos la Información personal según sea necesario para
                cumplir con nuestras obligaciones tributarias, contables y de
                registro, para proporcionarle los servicios que ha solicitado,
                así como un período adicional de tiempo necesario para proteger,
                defender o hacer valer nuestros derechos, defendernos contra
                posibles reclamos y cumplir con nuestras obligaciones legales.
                En algunos casos, en lugar de eliminar su Información personal,
                podríamos anonimizarla o agregarla y utilizarla en conformidad
                con la CCPA. Propósitos para la recopilación, uso, divulgación y
                procesamiento de la Información personal. Como se describe en
                detalle en la Sección 3: Para qué usamos los datos personales ,
                recopilamos, utilizamos y procesamos las categorías
                anteriormente nombradas de Información personal para brindarle
                nuestros Servicios, responder y cumplir con sus solicitudes,
                según lo que usted disponga o acepte, y para los siguientes
                propósitos comerciales: proporcionar servicios y asistencia
                técnica, comunicaciones, análisis y mejora, personalización,
                marketing y publicidad, eventos, investigación y estudios,
                seguridad y protección de derechos, acciones y obligaciones
                legales, y apoyo general al aspecto administrativo y operativo.
                Información personal sensible. No utilizamos ni divulgamos
                Información personal sensible más allá de los propósitos
                autorizados por la CCPA. Derechos de los residentes de
                California. La CCPA le otorga ciertos derechos con respecto a su
                Información personal. Tenga en cuenta que estos derechos están
                sujetos a ciertas condiciones y excepciones. Derecho a
                saber/solicitar acceso. Con respecto a la Información personal
                que hemos recopilado sobre usted en los últimos doce (12) meses,
                tiene derecho a saber lo siguiente: Las categorías de
                Información personal que recopilamos sobre usted; Las categorías
                de las fuentes de las cuales recopilamos su Información
                personal: Los propósitos corporativos o comerciales para
                recopilar, vender o divulgar su Información personal; Las
                categorías de terceros a quienes hemos divulgado su Información
                personal; y Qué Información personal específica recopilamos
                sobre usted. Derecho a eliminar. Tiene derecho a solicitar que
                eliminemos su Información personal Derecho a corregir. Tiene
                derecho a solicitar que corrijamos datos que no sean precisos
                dentro de su Información personal Derecho a optar por no
                participar en ventas y divulgación de información. Tiene derecho
                a optar por no participar en la “venta” y ” divulgación ” de su
                Información personal, según se define en la CCPA. Para ejercer
                el derecho a optar por no participar en la “venta” o
                “divulgación” de su Información personal, haga click en el link
                a Preferencias de Cookies al pie del Sitio o en este link. Tenga
                en cuenta que la solicitud de exclusión solo lo excluirá de
                divulgaciones consideradas “ventas” o “divulgaciones” según la
                CCPA y no lo excluirá de otras divulgaciones, como a nuestros
                proveedores de servicios. También tiene derecho a optar por no
                participar en la “venta” y “divulgación” de su Información
                personal mediante el uso de una señal de preferencia de
                exclusión. Si detectamos que su navegador o dispositivo está
                transmitiendo una señal de preferencia de exclusión, como la
                señal de “control global de privacidad” o “GPC”, excluiremos
                para ese navegador o dispositivo las cookies que generan la
                “venta” o “divulgación” de su Información personal. Si accede a
                nuestro Sitio o utiliza nuestros Servicios desde un dispositivo
                o un navegador diferente, también deberá optar por no participar
                o utilizar una señal de preferencia de exclusión para ese
                navegador y/o dispositivo. Derecho a limitar el uso de la
                Información personal sensible. No participamos en usos o
                divulgaciones de “Información Personal Sensible” que darían
                lugar al derecho a limitar el uso de Información personal
                sensible según la CCPA. Derecho a la no discriminación. No
                padecerá ninguna discriminación por reclamar alguno de los
                derechos descritos en esta sección.
              </p>
            </div>
          </div>
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </>
  );
}
